/* import components */
import Card from 'react-bootstrap/Card';
import BadgeOutline from './BadgeOutline';
import ChevronRight from './icons/ChevronRight';

/* import services */
import { getDateTime } from '../utils/utils';

const TripCard = (props) => {

    return (
        <>
            <Card className="trip-card" onClick={props.onClick}>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "0" }}>
                    <div>
                        <Card.Title 
                            className="grey font-bold" 
                            style={{ fontSize: "14px" }}>
                                Ride to {props.trip.endPlace}
                                {props.trip.additionalStopsCount > 0 ? ` (+${props.trip.additionalStopsCount})` : ""}
                        </Card.Title>
                        <Card.Subtitle className="grey topics">
                            {props.trip.time ? getDateTime(props.trip.time, "utc") : getDateTime(props.trip.rideStartTime, "utc")}
                        </Card.Subtitle>
                        <BadgeOutline title={props.trip.serviceType} />
                    </div>
                    {props.showChevron ?
                    <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                        <ChevronRight size="16" fill="#6D7278"/>
                    </div>
                    : ""}
                </div>
            </Card>
        </>
    );
}

export default TripCard;